import React from 'react';
import { useAuth } from '../context/AuthContext';
import OpsDashboard from './OpsDashboard';
import UserDashboard from './UserDashboard';

// Route the home dashboard by role. Legal/admin (canWriteContracts) get the
// ops/portfolio view; everyone else gets the self-serve user dashboard.
export default function Dashboard() {
  const { canWriteContracts } = useAuth();
  return canWriteContracts ? <OpsDashboard /> : <UserDashboard />;
}
